import { useId } from 'react';
import { SvgIcon } from '../SvgIcon';

export const SatisfactionSurveyIcon = ({
	fillColor = 'currentColor',
	width = 19,
	height = 19,
}: {
	fillColor?: string;
	width?: number;
	height?: number;
}) => {
	const id = useId();

	return (
		<SvgIcon width={width} height={height} viewBox='0 0 19 19'>
			<g id={id} stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id={`${id}-Updated-Survey-Icons`} transform='translate(-80, -156)' fill={fillColor}>
					<g id={`${id}-Satisfaction-Survey-Icon-Copy`} transform='translate(80, 156)' fill={fillColor}>
						<g id={`${id}-Fill-1761-+-Fill-1762-Copy-2`}>
							<path
								d='M4.16666667,3.33406961 L1.66666667,3.33406961 L1.66666667,1.6670348 L4.16666667,1.6670348 L4.16666667,3.33406961 Z M16.6666667,3.33406961 L10,3.33406961 L10,1.6670348 L16.6666667,1.6670348 L16.6666667,3.33406961 Z M5.83333333,1.6670348 L8.33333333,1.6670348 L8.33333333,3.33406961 L5.83333333,3.33406961 L5.83333333,1.6670348 Z M1.66666667,5.00110441 L16.6666667,5.00110441 L16.665,9.16452383 L18.3333333,9.16452383 L18.3333333,1.6670348 C18.3333333,0.747665109 17.5858333,0 16.6666667,0 L1.66666667,0 C0.7475,0 0,0.747665109 0,1.6670348 L0,15.0033132 C0,15.9235164 0.7475,16.670348 1.66666667,16.670348 L8.33333333,16.670348 L8.33333333,15.0033132 L1.66666667,15.0033132 L1.66666667,5.00110441 Z'
								id={`${id}-Fill-1761`}
							/>
						</g>
						<path
							d='M14.1856472,9.46422621 L15.3780503,12.4459299 C15.4084191,12.5218694 15.4819649,12.5716667 15.5637517,12.5716667 L18.4530071,12.5716667 C18.563464,12.5716667 18.6530071,12.6612097 18.6530071,12.7716667 C18.6530071,12.8305797 18.6270329,12.886496 18.5820144,12.924497 L16.0237705,15.083964 C15.9562508,15.1409588 15.9341327,15.2355064 15.9693631,15.3165381 L17.301814,18.381242 C17.3458552,18.4825391 17.2994402,18.6003591 17.1981431,18.6444004 C17.1360598,18.6713926 17.0645359,18.6651466 17.0080709,18.627802 L14.1103155,16.7112935 C14.0434236,16.6670527 13.9565733,16.6670481 13.8896767,16.7112816 L10.9912143,18.6278104 C10.8990777,18.6887332 10.7749985,18.6634294 10.7140757,18.5712928 C10.6767342,18.5148193 10.6704981,18.4432883 10.6975038,18.381205 L12.0306005,15.3165534 C12.0658512,15.2355157 12.0437378,15.1409491 11.9762078,15.0839456 L9.41798562,12.924497 C9.33357974,12.8532483 9.32291379,12.7270653 9.39416254,12.6426594 C9.43216359,12.5976409 9.48807988,12.5716667 9.54699291,12.5716667 L12.4354443,12.5716667 C12.5172165,12.5716667 12.5907521,12.521887 12.6211307,12.4459672 L13.8142595,9.46418886 C13.8552945,9.36163711 13.9716946,9.31176798 14.0742464,9.35280303 C14.1250619,9.37313634 14.1653241,9.41340664 14.1856472,9.46422621 Z'
							id={`${id}-Fill-1750`}
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
